type dataType = URLSearchParams | Record<string, string>;

/**
 * Éxécute une requête POST
 * 
 * @param url
 * @param data
 * @param signal
 */
export async function postData(url: string, data: dataType = {}, signal: AbortSignal|null = null) {
    const body = (data instanceof URLSearchParams ? data : new URLSearchParams(data));

    const args: RequestInit = {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
        credentials: 'same-origin',
        body,
    };

    if (signal) {
        args.signal = signal;
    }

    const response = fetch(url, args);
    return response.then(r => r.json());
}

/**
 * Éxécute une requête GET
 * 
 * @param url
 * @param data
 * @param signal
 */
export async function getData(url: string, data: dataType = {}, signal: AbortSignal|null = null) {
    const args: RequestInit = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
    };

    if (signal) {
        args.signal = signal;
    }

    url += '?' + (data instanceof URLSearchParams ? data : new URLSearchParams(data));

    const response = fetch(url, args);
    return response.then(r => r.json());
}
